import React from 'react';
import { Helmet } from 'react-helmet-async';

export const Privacy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Chinese Food Maps</title>
        <meta name="description" content="Learn how Chinese Food Maps protects your privacy and handles your data. Our comprehensive privacy policy explains what information we collect, how we use it, and the measures we take to keep your data secure." />
        <meta property="og:title" content="Privacy Policy | Chinese Food Maps" />
        <meta property="og:description" content="Learn how Chinese Food Maps protects your privacy and handles your data. Our comprehensive privacy policy explains what information we collect, how we use it, and the measures we take to keep your data secure." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://chinesefoodmaps.com/privacy" />
        <meta property="og:image" content="https://cdn-icons-png.flaticon.com/512/2548/2548242.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | Chinese Food Maps" />
        <meta name="twitter:description" content="Learn how Chinese Food Maps protects your privacy and handles your data." />
        <meta name="twitter:image" content="https://cdn-icons-png.flaticon.com/512/2548/2548242.png" />
        <link rel="canonical" href="https://chinesefoodmaps.com/privacy" />
      </Helmet>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-red-900">Privacy Policy</h1>
        
        <div className="bg-white rounded-lg shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Information We Collect</h2>
            <p className="text-gray-700 mb-4">
              We collect location data only when you explicitly provide it through the search function or "Use My Location" feature. This data is used solely to find Chinese restaurants near you and is never stored or shared with third parties.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">How We Use Your Information</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>To provide location-based search results for Chinese restaurants</li>
              <li>To improve our service and user experience</li>
              <li>To respond to your inquiries and support requests</li>
              <li>To enhance our restaurant recommendations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Third-Party Services</h2>
            <p className="text-gray-700 mb-4">
              We use Google Maps to provide location services and display Chinese restaurants. Your use of Google Maps is subject to Google's Privacy Policy. We also integrate with various review platforms to provide comprehensive restaurant information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Data Security</h2>
            <p className="text-gray-700 mb-4">
              We implement industry-standard security measures to protect your information. Your location data is processed securely and is never stored permanently on our servers. We use HTTPS encryption for all data transmission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Cookies and Tracking</h2>
            <p className="text-gray-700 mb-4">
              We use cookies to improve your browsing experience and analyze site traffic. These cookies help us understand how you use Chinese Food Maps and allow us to enhance our service. You can control cookie settings through your browser preferences.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Contact Us</h2>
            <p className="text-gray-700">
              If you have any questions about our Privacy Policy, please contact us at chinesefoodmapsapp@gmail.com or through our Contact page.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};